import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Template } from '../../../invoice/models/dtos/template.model';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'kt-app-template-card',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './template-card.component.html',
  styleUrls: ['./template-card.component.scss']
})
export class TemplateCardComponent {
  @Input() template?: Template;
  @Output() selected = new EventEmitter<Template>();

  onSelect(): void {
    if (this.template) {
      this.selected.emit(this.template);
    }
  }
}
